export default {
  GET_HOT_TOURS: 'ott/tours/GET_HOT_TOURS',
  GET_HOT_TOURS_SUCCESS: 'ott/tours/GET_HOT_TOURS_SUCCESS',
  GET_HOT_TOURS_FAIL: 'ott/tours/GET_HOT_TOURS_FAIL',
};
